import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function toQuery(params = {}) {
  const qp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      if (typeof v === 'boolean') {
        qp.set(k, v ? '1' : '0');
      } else {
        qp.set(k, v);
      }
    }
  });
  return qp.toString();
}

/**
 * GET /api/admin/dashboard con filtros y paginación
 * @param {{date_start?:string,date_end?:string,advisor?:string,sum_field?:'monto'|'total',per_page?:number,get_all?:boolean}} filters
 * @param {number} page
 * @param {RequestInit} options
 */
export async function getDashboardLoans(filters, page = 1, options = {}) {
  const query = toQuery({ ...filters, page });
  const url = `${API_BASE_URL}/api/admin/dashboard?${query}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json', ...(options.headers || {}) },
    ...options,
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden ver este dashboard.');
  }
  if (res.status === 422) {
    const body = await res.json();
    const error = new Error(body?.message || 'Error de validación');
    error.status = 422;
    error.response = { data: body };
    throw error;
  }
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar el dashboard'}`);
  }

  return res.json();
}
